import { useState, useEffect } from 'react'
import { Sun, Moon } from 'lucide-react'

export default function ThemeToggle() {
  const [isDark, setIsDark] = useState(false)

  // 根据时间自动判断主题
  const getAutoTheme = () => {
    const hour = new Date().getHours()
    // 6:00-18:00 为白天模式，18:00-6:00 为黑夜模式
    return hour >= 6 && hour < 18 ? 'light' : 'dark'
  }

  useEffect(() => {
    // 从localStorage获取主题设置
    const savedTheme = localStorage.getItem('theme')
    // const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    
    let theme: string
    
    if (savedTheme) {
      // 如果有保存的主题设置，使用保存的设置
      theme = savedTheme
    } else {
      // 如果没有保存的设置，根据时间自动选择
      theme = getAutoTheme()
      // 保存自动选择的主题
      localStorage.setItem('theme', theme)
    }
    
    // 应用主题
    if (theme === 'dark') {
      setIsDark(true)
      document.documentElement.setAttribute('data-theme', 'dark')
    } else {
      setIsDark(false)
      document.documentElement.removeAttribute('data-theme')
    }
  }, [])

  const toggleTheme = () => {
    const newTheme = !isDark
    setIsDark(newTheme)
    
    if (newTheme) {
      document.documentElement.setAttribute('data-theme', 'dark')
      localStorage.setItem('theme', 'dark')
    } else {
      document.documentElement.removeAttribute('data-theme')
      localStorage.setItem('theme', 'light')
    }
  }

  return (
    <div className="fixed z-[9999] top-4 left-4 sm:top-6 sm:left-6 flex items-center space-x-3">
      {/* 当前模式显示 */}
      <div 
        className="px-3 py-2 rounded-lg transition-all duration-300 backdrop-blur-md shadow-lg border"
        style={{
          background: isDark ? 'rgba(0, 0, 0, 0.4)' : 'rgba(255, 255, 255, 0.2)',
          backdropFilter: 'blur(16px)',
          boxShadow: isDark 
            ? '0 4px 16px 0 rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)' 
            : '0 4px 16px 0 rgba(255, 255, 255, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.2)',
          border: isDark ? '1px solid rgba(255, 255, 255, 0.2)' : '1px solid rgba(255, 255, 255, 0.3)',
        }}
      >
        <span className="text-xs sm:text-sm font-medium text-white/80">
          {isDark ? '暗色模式' : '明亮模式'}
        </span>
      </div>

      {/* 切换按钮 */}
      <button
        onClick={toggleTheme}
        className="p-2 sm:p-3 rounded-full transition-all duration-300 backdrop-blur-md shadow-xl border-2 hover:scale-110 hover:shadow-2xl"
        style={{
          background: isDark ? 'rgba(0, 0, 0, 0.6)' : 'rgba(255, 255, 255, 0.3)',
          backdropFilter: 'blur(16px)',
          boxShadow: isDark 
            ? '0 8px 32px 0 rgba(14, 165, 233, 0.5), 0 4px 16px 0 rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.1)' 
            : '0 8px 32px 0 rgba(14, 165, 233, 0.4), 0 4px 16px 0 rgba(255, 255, 255, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.2)',
          border: isDark ? '2px solid rgba(255, 255, 255, 0.3)' : '2px solid rgba(255, 255, 255, 0.4)',
          minWidth: '40px',
          minHeight: '40px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          userSelect: 'none'
        }}
        title={isDark ? '切换到明亮模式' : '切换到暗色模式'}
        aria-label={isDark ? '切换到明亮模式' : '切换到暗色模式'}
      >
        {isDark ? (
          <Sun className="w-5 h-5 sm:w-6 sm:h-6 text-yellow-300 animate-pulse" style={{ filter: 'drop-shadow(0 0 8px rgba(251, 191, 36, 0.6))' }} />
        ) : (
          <Moon className="w-5 h-5 sm:w-6 sm:h-6 text-blue-500 animate-pulse" style={{ filter: 'drop-shadow(0 0 8px rgba(59, 130, 246, 0.6))' }} />
        )}
      </button>
    </div>
  )
} 